// extracted by mini-css-extract-plugin
module.exports = {"PsliTable":"M0u+DCLz5rkzsp86P00ULw==","CheckboxCell":"rpKE6dV4o5GWRbUvroIrYg=="};